import React from 'react';

const FormRenderer = ({ schema, values, onChange, errors }) => {
  if (!schema || !schema.custom_fields) {
    return <div>No hay campos para mostrar</div>;
  }

  const renderField = (field) => {
    field = {...field, ...field.field};
    const fieldValue = values[field.id] || field.default || '';
    const fieldError = errors[field.id];
    switch (field.type) {
      case 'text':
      case 'string':
        return (
          <div key={field.id} className="form-group">
            <label htmlFor={field.id}>
              {field.name} {field.required && '*'}
            </label>
            <input
              type="text"
              id={field.id}
              value={fieldValue}
              onChange={(e) => onChange(field.id, e.target.value)}
              className={fieldError ? 'error' : ''}
              required={field.required}
              placeholder={field.help}
            />
            {fieldError && <span className="error-message">{fieldError}</span>}
          </div>
        );

      case 'textarea':
        return (
          <div key={field.id} className="form-group">
            <label htmlFor={field.id}>
              {field.name} {field.required && '*'}
            </label>
            <textarea
              id={field.id}
              value={fieldValue}
              onChange={(e) => onChange(field.id, e.target.value)}
              className={fieldError ? 'error' : ''}
              required={field.required}
              placeholder={field.help}
              rows="4"
            />
            {fieldError && <span className="error-message">{fieldError}</span>}
          </div>
        );

      case 'number':
      case 'decimal':
        return (
          <div key={field.id} className="form-group">
            <label htmlFor={field.id}>
              {field.name} {field.required && '*'}
            </label>
            <input
              type="number"
              step="0.01"
              id={field.id}
              value={fieldValue}
              onChange={(e) => onChange(field.id, e.target.value)}
              className={fieldError ? 'error' : ''}
              required={field.required}
              placeholder={field.help}
            />
            {fieldError && <span className="error-message">{fieldError}</span>}
          </div>
        );

      case 'date':
        return (
          <div key={field.id} className="form-group">
            <label htmlFor={field.id}>
              {field.name} {field.required && '*'}
            </label>
            <input
              type="date"
              id={field.id}
              value={fieldValue}
              onChange={(e) => onChange(field.id, e.target.value)}
              className={fieldError ? 'error' : ''}
              required={field.required}
            />
            {fieldError && <span className="error-message">{fieldError}</span>}
          </div>
        );

      case 'select':
        return (
          <div key={field.id} className="form-group">
            <label htmlFor={field.id}>
              {field.name} {field.required && '*'}
            </label>
            <select
              id={field.id}
              value={fieldValue}
              onChange={(e) => onChange(field.id, e.target.value)}
              className={fieldError ? 'error' : ''}
              required={field.required}
            >
              <option value="">Seleccionar...</option>
              {field.options && field.options.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {fieldError && <span className="error-message">{fieldError}</span>}
          </div>
        );

      case 'boolean':
        return (
          <div key={field.id} className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                id={field.id}
                checked={fieldValue === 'true' || fieldValue === true}
                onChange={(e) => onChange(field.id, e.target.checked.toString())}
                className={fieldError ? 'error' : ''}
                required={field.required}
              />
              <span className="checkbox-text">
                {field.name} {field.required && '*'}
              </span>
            </label>
            {fieldError && <span className="error-message">{fieldError}</span>}
          </div>
        );

      case 'composite':
        return (
          <div key={field.id} className="form-group composite-field">
            <h4>{field.name} {field.required && '*'}</h4>
            {field.parts && field.parts.map(part => (
              <div key={`${field.id}.${part.id}`} className="composite-part">
                <label htmlFor={`${field.id}.${part.id}`}>
                  {part.label}
                </label>
                {part.type === 'select' ? (
                  <select
                    id={`${field.id}.${part.id}`}
                    value={values[`${field.id}.${part.id}`] || ''}
                    onChange={(e) => onChange(`${field.id}.${part.id}`, e.target.value)}
                  >
                    <option value="">Seleccionar...</option>
                    {part.options && part.options.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type={part.type === 'number' ? 'number' : 'text'}
                    id={`${field.id}.${part.id}`}
                    value={values[`${field.id}.${part.id}`] || ''}
                    onChange={(e) => onChange(`${field.id}.${part.id}`, e.target.value)}
                  />
                )}
              </div>
            ))}
            {fieldError && <span className="error-message">{fieldError}</span>}
          </div>
        );

      default:
        return (
          <div key={field.id} className="form-group">
            <label htmlFor={field.id}>
              {field.name} {field.required && '*'}
            </label>
            <input
              type="text"
              id={field.id}
              value={fieldValue}
              onChange={(e) => onChange(field.id, e.target.value)}
              className={fieldError ? 'error' : ''}
              required={field.required}
              placeholder={field.help}
            />
            {fieldError && <span className="error-message">{fieldError}</span>}
          </div>
        );
    }
  };

  // Agrupar campos por meta.scope si existe
  const groupedFields = schema.custom_fields.reduce((groups, field) => {
    const scope = field.meta?.scope || 'default';
    if (!groups[scope]) {
      groups[scope] = [];
    }
    groups[scope].push(field);
    return groups;
  }, {});

  return (
    <div className="form-renderer">
      {Object.entries(groupedFields).map(([scope, fields]) => (
        <div key={scope} className={`field-group ${scope}`}>
          {scope !== 'default' && <h3>{scope}</h3>}
          <div className="fields-grid">
            {fields
              .sort((a, b) => (a.order || 0) - (b.order || 0))
              .map(renderField)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FormRenderer;
